import React from 'react';
import PropTypes from 'prop-types';
import { Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'i18n';
import { capitalize } from 'helpers/utils';
import { formatTime } from 'helpers/format';
import { isStoreClosedHelper } from 'helpers/menuManagementHours';

const NS = 'modifierGroup';

export default function HoursLine({ hoursData, showToday = false }) {
  const { t } = useTranslation(NS);
  const { dayIndex, openTimes } = hoursData;

  function getDay() {
    // Get first 3 letters of the day (Mon, Tue, etc.)
    return dayIndex.substring(0, 3);
  }

  function getTime(time) {
    if (isStoreClosedHelper(time)) return t('HoursLine.closed');
    return `${formatTime(time.startTime)} – ${formatTime(time.endTime)}`;
  }

  return (
    <Group align="flex-start">
      <Text variant="sublabel-sm" w="var(--dimension-xl6)" flex="0 0 auto">
        {capitalize(getDay())}
        {showToday && ` ${t('HoursLine.today')}`}
      </Text>
      <Stack gap="xs2">
        {openTimes.map(time => (
          <Text key={time.startTime} variant="sublabel-sm" style={{ whiteSpace: 'nowrap' }}>
            {getTime(time)}
          </Text>
        ))}
      </Stack>
    </Group>
  );
}

HoursLine.propTypes = {
  hoursData: PropTypes.shape({
    dayIndex: PropTypes.string,
    openTimes: PropTypes.arrayOf(
      PropTypes.shape({ startTime: PropTypes.string, endTime: PropTypes.string }),
    ),
  }).isRequired,
  showToday: PropTypes.bool,
};
